import styled, { createGlobalStyle } from 'styled-components';

import NavButton from './NavButton';
import PropTypes from 'prop-types';
import { default as RSlider } from 'react-slick';
import React from 'react';
import { media } from '../../styles/media';

const GlobalStyle = createGlobalStyle`
 .slick-slider
  {
      position: relative;

      display: block;
      box-sizing: border-box;

      user-select: none;

      touch-action: pan-y;
      -webkit-tap-highlight-color: transparent;
      margin-bottom: 20px;
  }

  .slick-list
  {
      position: relative;

      display: block;
      overflow: hidden;

      margin: 0;
      padding: 0;
  }
  .slick-list:focus
  {
      outline: none;
  }
  .slick-list.dragging
  {
      cursor: pointer;
      cursor: hand;
  }

  .slick-slider .slick-track,
  .slick-slider .slick-list
  {
      -webkit-transform: translate3d(0, 0, 0);
        -moz-transform: translate3d(0, 0, 0);
          -ms-transform: translate3d(0, 0, 0);
          -o-transform: translate3d(0, 0, 0);
              transform: translate3d(0, 0, 0);
  }

  .slick-track
  {
      position: relative;
      top: 0;
      left: 0;

      display: flex;
      margin-left: auto;
      margin-right: auto;

      overflow-x: auto;
  }
  .slick-track:before,
  .slick-track:after
  {
      display: table;

      content: '';
  }
  .slick-track:after
  {
      clear: both;
  }
  .slick-loading .slick-track
  {
      visibility: hidden;
  }

  .slick-slide
  {
      display: none;
      height: 100%;
      width: 100%;
      min-height: 1px;
  }

  ${media.desktop`
    .slick-slide
    {
        width: auto;
    }
  `};

  [dir='rtl'] .slick-slide
  {
      float: right;
  }
  .slick-slide img
  {
      display: block;
  }
  .slick-slide.slick-loading img
  {
      display: none;
  }
  .slick-slide.dragging img
  {
      pointer-events: none;
  }
  .slick-initialized .slick-slide
  {
      display: block;
  }
  .slick-loading .slick-slide
  {
      visibility: hidden;
  }
  .slick-vertical .slick-slide
  {
      display: block;

      height: auto;

      border: 1px solid transparent;
  }
  .slick-arrow.slick-hidden {
      display: none;
  }
  /* Arrows */
.slick-prev,
.slick-next
{


    transform: translate(0, -50%);

    cursor: pointer;

    color: transparent;
    border: none;
    outline: none;
    background: transparent;
}
.slick-prev:hover,
.slick-prev:focus,
.slick-next:hover,
.slick-next:focus
{
    color: transparent;
    outline: none;
    background: transparent;
}


.slick-prev
{
    left: -15px;
}
[dir='rtl'] .slick-prev
{
    right: -15px;
    left: auto;
}


.slick-next
{
    right: -15px;
}
[dir='rtl'] .slick-next
{
    right: auto;
    left: -15px;
}

/* Dots */
.slick-dotted.slick-slider
{
    margin-bottom: 30px;
}

.slick-dots
{
    position: absolute;
    bottom: -25px;

    display: block;

    width: 100%;
    padding: 0;
    margin: 0;

    list-style: none;

    text-align: center;
}
.slick-dots li
{
    position: relative;

    display: inline-block;

    height: 20px;
    width: auto;
    margin: 0 3px;
    padding: 0;

    cursor: pointer;
}
.slick-dots li button
{
    font-size: 0;
    line-height: 0;

    display: block;

    width: 20px;
    height: 20px;
    padding: 5px;

    cursor: pointer;

    color: transparent;
    border: 0;
    outline: none;
    background: transparent;
}
.slick-dots li button:hover,
.slick-dots li button:focus
{
    outline: none;
}


`;

const Item = styled.div`
  padding: ${props => props.theme.layout.gutter / 2}px;
  flex: 0 0 auto;

  ${media.desktop`
    padding: ${props => props.theme.layout.gutter * 1.5}px;
    flex: ${props => (props.infinite ? '0 0 auto' : '1')};
    max-width: ${props => (props.unslick ? '100%' : '40%')};
  `};
`;

class Slider extends React.PureComponent {
  renderSlide = (slide, index) => {
    const { infinite, unslick } = this.props;
    return (
      <Item key={index} infinite={infinite} unslick={unslick}>
        {slide}
      </Item>
    );
  };

  renderSlides = slides => {
    return slides.map(this.renderSlide);
  };

  render() {
    const { children, ...rest } = this.props;
    const settings = {
      speed: 500,
      nextArrow: <NavButton icon="arrowRight" />,
      prevArrow: <NavButton icon="arrowLeft" />,
      ...rest
    };
    return (
      <React.Fragment>
        <GlobalStyle />
        <RSlider {...settings}>{this.renderSlides(children)}</RSlider>
      </React.Fragment>
    );
  }
}

Slider.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]),
  infinite: PropTypes.bool,
  unslick: PropTypes.bool
};

export default Slider;
